export default "__VITE_ASSET__BK7s_DpI__"